<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Túranaptár</span>
      <div style="float: right">
        <el-button
          style=" margin-top: -5px;"
          type="success"
          size="small"
          @click="$router.replace('/representative-processes/tour-calendars/add')"
          icon="el-icon-plus"
          v-can="'tourcalendar.create'"
        >
          Új túranap
        </el-button>

        <el-button
          style="margin-top: -5px;"
          type="primary"
          size="small"
          @click="$router.replace('/representative-processes/tour-calendar-rules/')"
          icon="el-icon-edit"
          v-can="'tourcalendarrules.view'"
        >
          Szabályok szerkesztése
        </el-button>
      </div>

    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="tourCalendar/fetchAll"
      />
    </div>
    <tour-calendar-list />
    <template v-if="$route.meta.showAddTourCalendarDialog">
      <tour-calendar-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateTourCalendarDialog">
      <tour-calendar-dialog
        :tour-calendar-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import tourCalendarList from '../../components/representativeProcesses/tourCalendars/List';
  import tourCalendarDialog from '../../components/representativeProcesses/tourCalendars/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      tourCalendarList,
      tourCalendarDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        if(!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.filterConfig = [
          {
            type: 'select',
            name: 'user',
            options: users,
            label: 'Képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
            defaultSearch: true,
          },
          {
            type: 'multipleRemoteSelect',
            name: 'shop_id',
            label: 'Üzlet',
            labelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'shop/search',
          },
          {
            type: 'dateRange',
            name: 'start_date',
            label: 'Kezdés időpontja',
          }, {
            type: 'dateRange',
            name: 'start_date',
            label: 'Kezdés időpontja',
          },
        ];
      },
    },
  };
</script>
